<iot-platform-ui-date-time
  class="date-cell"
  [dateValue]="$safeNavigationMigration(params()?.value)"
  [dateFormat]="dateFormat()"
  [dateTimezone]="dateTimezone()"
  [removeTimezone]="removeTimezone()"
/>
